<template>
    <div class="dashboard-wrapper">
        <action-count-widgets>

        </action-count-widgets>

        <b-container fluid v-if="$can($perm.ADMIN_VIEW_ACTION_STATUS_REPORTS, $perm.PERMISSION_TYPE_ADMIN)">
            <b-row class="h-100 mt-3">
                <b-col cols="12" lg="9" class="mb-3 d-none d-md-block">
                    <action-due-date-widget class="widget"></action-due-date-widget>
                </b-col>
                <b-col cols="12" lg="3" class="mb-3">
                    <action-progress-widget class="widget"></action-progress-widget>
                </b-col>
            </b-row>

            <b-row
                v-if="$can($perm.ADMIN_VIEW_OWN_TEAM_USERS, $perm.PERMISSION_TYPE_ADMIN)
                    && hasUserTeams"
            >
                <b-col>
                    <team-grid :userTeams="userTeams"></team-grid>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import ActionItem from '@/components/Action/Action';
import TeamGrid from '@/components/Team/TeamGrid';
import ActionCountWidgets from '@/components/Widgets/ActionCountWidgets';
import ActionProgressWidget from '@/components/Widgets/ActionProgressWidget';
import ActionDueDateWidget from '@/components/Widgets/ActionDueDateWidget';
import PropertyAssessmentType from '@/services/Property/PropertyAssessmentType';

export default {
  name: 'Dashboard',
  components: {
    ActionCountWidgets,
    ActionDueDateWidget,
    ActionProgressWidget,
    TeamGrid,
    ActionItem,
  },
  data() {
    return {
      userTeams: [],
    };
  },
  computed: {
    hasUserTeams() {
      return !!(this.userTeams.length);
    },
  },
  methods: {
    setUserTeams() {
      const user = this.$store.getters.authUser;
      const { teams } = user;

      this.userTeams = teams;
    },
  },
  created() {
    this.setUserTeams();
  },
  mounted() {
    this.$store.dispatch('fetchUser');

    // Get results for FIRE RISK only
    this.$store.dispatch('refreshCounts', PropertyAssessmentType.COMPLIANCE_TYPE_FIRE_ID());
  },
};
</script>

<style lang="scss">
    .dashboard-wrapper {
        margin-bottom: 2em;
        color: #24415E;
        .widget {
            .card-body {
                padding: 0;
                .card-header {
                    padding: 15px;
                    border-bottom: 1px solid #E1E6EB;
                    background: #FFF;
                    min-height: 62px;
                    .card-title {
                        font-weight: bold;
                        font-size: 21px;
                        margin: 0;
                    }
                }
                .card-text {
                    padding: 15px;
                }
            }
        }
        .btn-secondary {
            color: #4E738A;
            background-color: #ffffff;
            border-color: #C9D5DB;
            padding: 3px 8px;
            border-radius: 0;
        }
        .grid-wrapper {
            h3 {
                color: #24415E;
                font-weight: 700;
                font-size: 21px;
            }
            .ag-theme-balham {
                font-size: 16px;
                color: #333333;
                .ag-header {
                    background-color: #24415E;
                    font-size: 16px;
                    .ag-header-row {
                        color: #FFF;
                    }
                }
                .ag-row {
                    &.ag-row-even {
                        background-color: rgba(36, 65, 94, 0.05);
                    }
                    &.ag-row-odd {
                        background-color: #FFF;
                    }
                }
            }
            .ag-body-container {
                width: 100% !important;
            }
        }
    }

    @media only screen and (max-width : 768px) {
        .dashboard-wrapper {
            .grid-wrapper {
                .container-fluid {
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
        }
    }
</style>
